/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_EmailInputs */

const en_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ar_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const bn_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমেইল`)
};

const de_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const es_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

const fr_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const pt_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const zh_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const tr_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const ru_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`электронная почта`)
};

const pl_resume_email = /** @type {(inputs: Resume_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Resume_EmailInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_email = /** @type {((inputs?: Resume_EmailInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_EmailInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_email(inputs)
	if (locale === "bn") return bn_resume_email(inputs)
	if (locale === "de") return de_resume_email(inputs)
	if (locale === "es") return es_resume_email(inputs)
	if (locale === "fr") return fr_resume_email(inputs)
	if (locale === "pt") return pt_resume_email(inputs)
	if (locale === "zh") return zh_resume_email(inputs)
	if (locale === "tr") return tr_resume_email(inputs)
	if (locale === "ru") return ru_resume_email(inputs)
	if (locale === "pl") return pl_resume_email(inputs)
	return en_resume_email(inputs)
});